import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useSegmentPreview = () => {
    const additional = useQueryRequestParams();
    return useMutation({
        mutationFn: (body) => axios.post(markUrl('segments/preview/'), body, additional)
    });
};
export default useSegmentPreview;
